<template>
    <div class="audit-timeline mt-2">
        <div class="audit-timeline-header">
            <button class="close-button" @click="$emit('close')">
                <i class="fas fa-times"></i>
            </button>
        </div>
        <div
            v-for="(times, date) in groupedAudits(invoiceItem)"
            :key="date"
            class="audit-timeline-group"
        >
            <div class="audit-timeline-date">
                {{ date }}
            </div>
            <div
                v-for="(audits, time) in times"
                :key="time"
                class="audit-timeline-time-group"
            >
                <div class="audit-timeline-time">
                    {{ time }}
                </div>
                <div class="audit-timeline-time-items">
                    <div
                        v-for="(audit, idx) in audits"
                        :key="idx"
                        class="audit-timeline-item"
                    >
                        <div class="audit-timeline-details">
                            <div
                                class="audit-timeline-summary"
                                v-html="audit.summary"
                            ></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AuditSummary",
    props: {
        invoiceItem: {
            type: Object,
            required: true
        }
    },
    methods: {
        groupedAudits(invoiceItem) {
            const audits =
                invoiceItem.item_dispensing_references[0]?.audits || [];

            // Group by formatted date and time
            return audits.reduce((acc, audit) => {
                const date = this.formatDate(audit.create_at, "date");
                const time = this.formatDate(audit.create_at, "time");

                if (!acc[date]) {
                    acc[date] = {};
                }
                if (!acc[date][time]) {
                    acc[date][time] = [];
                }
                acc[date][time].push(audit);

                return acc;
            }, {});
        },
        formatDate(date, type) {
            if (date === null) {
                return "";
            }

            if (type === "date") {
                return this._fromDateCarbon(date).toFormat("MMM d, yyyy");
            } else if (type === "time") {
                return this._fromDateCarbon(date).toFormat("hh:mm a");
            }

            return this._fromDateCarbon(date).toFormat("MMM d, yyyy h:mm a");
        }
    }
};
</script>
<style scoped>
.audit-timeline {
    background: #f8f9fa;
    border-radius: 8px;
    padding: 16px;
    border: 1px solid #e9ecef;
    position: relative;
}

.audit-timeline-header {
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 2;
}

.close-button {
    background: none;
    border: none;
    color: #6c757d;
    cursor: pointer;
    padding: 4px;
    font-size: 1rem;
    transition: color 0.2s ease;
}

.close-button:hover {
    color: #343a40;
}

.audit-timeline-group {
    margin-bottom: 20px;
}

.audit-timeline-group:first-child > .audit-timeline-date {
    margin-top: 0;
}

.audit-timeline-group:last-child {
    margin-bottom: 0;
}

.audit-timeline-date {
    font-size: 0.85rem;
    color: #6c757d;
    margin-bottom: 8px;
    margin-top: 8px;
}

.audit-timeline-time-group {
    display: flex;
    align-items: flex-start;
    position: relative;
}
.audit-timeline-time-group:not(:last-child) {
    padding-bottom: 12px;
}

.audit-timeline-time-group:not(:last-child)::before {
    content: "";
    position: absolute;
    left: 36px;
    top: 2px;
    bottom: -2px;
    width: 2px;
    background: #8e8e8e;
}

.audit-timeline-time {
    font-size: 0.75rem;
    background: #e9ecef;
    padding: 4px 10px;
    border-radius: 20px;
    color: #8e8e8e;
    text-align: center;
    position: relative;
    margin-right: 16px;
    margin-top: 2px;
    font-weight: 500;
    z-index: 1;
}

.audit-timeline-time-items {
    flex: 1;
    margin-top: 6px;
    position: relative;
}

.audit-timeline-item {
    position: relative;
}

.audit-timeline-item:not(:last-child) {
    margin-bottom: 8px;
    padding-bottom: 8px;
}

.audit-timeline-details {
    flex: 1;
}

.audit-timeline-status {
    margin-bottom: 4px;
    font-size: 0.9rem;
    color: #495057;
}

.audit-timeline-summary {
    color: #6c757d;
    font-size: 0.85rem;
    line-height: 1.4;
}
</style>
